import React from 'react'
import Popup from '../../components/organisms/Popup/index'
import PopupBox from './PopupBox'
import PopupContent from './PopupContent'
import PopupHeader from './PopupHeader'

const PopupContext = React.createContext(false)
const {Consumer: PopupConsumer} = PopupContext

const withPopup = Component => props => (
  <PopupConsumer>
    {popup => <Component {...props} popup={popup} />}
  </PopupConsumer>
)

export {withPopup}

export default ({
  wrap,
  onClose,
  children,
  isLoading,
  isOpen,
  preventCickOutside,
  componentName
}) => {
  return wrap ? (
    <Popup data-popup-id={componentName} onClose={onClose} open={isOpen}>
      <PopupBox onClose={onClose}>
        <PopupHeader />
        <PopupContent>
          <PopupContext.Provider value={true}>{children}</PopupContext.Provider>
        </PopupContent>
      </PopupBox>
    </Popup>
  ) : (
    <Popup
      data-popup-id={componentName}
      disableBackdropClick={preventCickOutside}
      disableEscapeKeyDown={preventCickOutside}
      onClose={onClose}
      open={isOpen}
    >
      <PopupContext.Provider value={true}>{children}</PopupContext.Provider>
    </Popup>
  )
}



// WEBPACK FOOTER //
// ./src/shared/components/popup/PopupWrapper.js